import { Component, OnInit } from '@angular/core';
import { Language } from './Language';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-language',
  templateUrl: './language.component.html'
})
export class LanguageComponent extends BaseModalContainer<Language> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Language>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
  }

  ngOnInit() {
  }

}
